import { render } from "./CIS-Controls-Resources-Nav.vue?vue&type=template&id=5c468346&scoped=true"
import script from "./CIS-Controls-Resources-Nav.vue?vue&type=script&lang=js"
export * from "./CIS-Controls-Resources-Nav.vue?vue&type=script&lang=js"

import "./CIS-Controls-Resources-Nav.vue?vue&type=style&index=0&id=5c468346&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c468346"]])

export default __exports__